import { render, staticRenderFns } from "./editInvoice.vue?vue&type=template&id=97c40c5e&scoped=true"
import script from "./editInvoice.vue?vue&type=script&lang=js"
export * from "./editInvoice.vue?vue&type=script&lang=js"
import style0 from "./editInvoice.vue?vue&type=style&index=0&id=97c40c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c40c5e",
  null
  
)

export default component.exports